module.exports = __webpack_public_path__ + "media/images/dotted-border-494ff96419deb1903709fec31ed9e8b5.svg";